import React from 'react'
import { connect } from 'react-redux'
import { string } from 'prop-types'
import { getDesignSidepanelMode } from 'models/ui/selectors'
import ProductBrowseView from 'components/designSidepanel/ProductBrowseView'

const ProductBrowseViewContainer = ({ mode }) => <ProductBrowseView mode={mode} />

ProductBrowseViewContainer.propTypes = {
    mode: string.isRequired,
}

const mapStateToProps = (state) => ({
    mode: getDesignSidepanelMode(state),
})

export default connect(mapStateToProps)(ProductBrowseViewContainer)
